var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ccn-button",class:("ccn-button--" + _vm.mode),attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit("click")}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }